import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_logs_cleanService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { integration_names: string[], levels_to_purge: number[], days_to_retain: number }): Promise<{ success?: boolean, count?: number, messages?: any[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.integration_names)) {
      missingRequiredInParams.push('\'integration_names\'');
    }
    if (isNil(inParams.levels_to_purge)) {
      missingRequiredInParams.push('\'levels_to_purge\'');
    }
    if (isNil(inParams.days_to_retain)) {
      missingRequiredInParams.push('\'days_to_retain\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/logs_clean`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

